import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-form',
	templateUrl:'./FormPluginCompPage.html',
	styles: [],
	styleUrls:['./FormPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class FormPluginCompPage
{
	mdContent_960 = `\`\`\`java
import com.jwebmp.core.base.html.Form;
\`\`\``;
	mdContent_961 = `\`\`\`java
Form()
\`\`\``;
	mdContent_962 = `\`\`\`java
Form&lt;?&gt; form = new Form&lt;&gt;();
form.setAction("/submit");
form.setMethod("POST");
form.add(new InputTextType&lt;&gt;().setPlaceholder("Name"));
form.add(new Button&lt;&gt;().setText("Submit"));
\`\`\``;
}
